import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
export const HeaderBar = ({ children }) => {
    const [domReady, setDomReady] = useState(false);
    useEffect(() => {
        const el = document.querySelector('.global-header');
        el && setDomReady(true);
    }, []);
    return domReady ? createPortal(children, document.querySelector('.global-header')) : _jsx(_Fragment, {});
};
